export default __webpack_public_path__ + "static/media/MP_Skills_Where_01.7dab5489.png";